import React, { useState, useEffect } from "react";
import { BrandMark } from "../icons/Logo";

export const Footer: React.FC = () => {
  const [isMobileView, setIsMobileView] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobileView(window.innerWidth <= 768);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);

    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  return (
    <footer
      style={{
        background: 'transparent',
        padding: isMobileView ? '32px 20px' : '40px 80px',
        fontFamily: "'Inter', sans-serif",
        borderTop: '1px solid rgba(196, 149, 106, 0.12)',
        position: 'relative'
      }}
    >
      {/* Copper gradient line at top */}
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: '50%',
          transform: 'translateX(-50%)',
          width: '200px',
          height: '1px',
          background: 'linear-gradient(90deg, transparent, #C4956A, transparent)',
          opacity: 0.5
        }}
      />

      <div
        style={{
          maxWidth: '1200px',
          margin: '0 auto',
          display: isMobileView ? 'flex' : 'grid',
          gridTemplateColumns: isMobileView ? 'none' : '1fr auto 1fr',
          flexDirection: isMobileView ? 'row' : 'row',
          justifyContent: isMobileView ? 'space-between' : 'initial',
          alignItems: 'center',
          gap: isMobileView ? '16px' : '24px'
        }}
      >
        {/* Left — Brand Mark */}
        <div style={{ textAlign: 'left' }}>
          <BrandMark size={32} />
        </div>

        {/* Center — Tagline */}
        {!isMobileView && (
          <p
            style={{
              fontSize: '13px',
              color: 'rgba(245, 245, 245, 0.35)',
              margin: 0,
              fontWeight: 400,
              textAlign: 'center',
              letterSpacing: '0.01em'
            }}
          >
            Building what's next.
          </p>
        )}

        {/* Right — Copyright */}
        <div style={{ textAlign: 'right' }}>
          <p
            style={{
              fontSize: '12px',
              color: 'rgba(245, 245, 245, 0.25)',
              margin: 0,
              fontWeight: 400,
              fontFamily: "'JetBrains Mono', monospace",
              letterSpacing: '0.02em'
            }}
          >
            © {new Date().getFullYear()} Asim Hafeez
          </p>
        </div>
      </div>
    </footer>
  );
};
